<template>
  <Layout name="LayoutDefault">
    <div class="pa-12">
      <h2 class="my-4 secondary--text">
        <SvgIcon
          width="25"
          height="25"
          class="mr-3"
          iconType="icon_user_settings"
        />{{ $t('portal.general.user_settings.labels.title') }}
      </h2>
      <v-tabs background-color="transparent" v-model="tab">
        <v-tab class="text-capitalize" id="idPortalPerfilDeUsuario">{{
          $t('portal.general.user_settings.labels.tab_profile')
        }}</v-tab>
        <!-- <v-tab class="text-capitalize">{{
          $t('portal.general.user_settings.labels.tab_settings')
        }}</v-tab>
        <v-tab class="text-capitalize">{{
          $t('portal.general.user_settings.labels.tab_notifications')
        }}</v-tab> -->

        <v-tab-item v-model="tab">
          <UserProfile class="mt-4" />
        </v-tab-item>

<!--        <v-tab class="text-capitalize" id="idPortalAdministrarDispositivos">{{-->
<!--          $t('portal.general.user_settings.labels.tab_sessions')-->
<!--        }}</v-tab>-->
<!--        <v-tab-item>-->
<!--          <AdminDevices class="mt-4" />-->
<!--        </v-tab-item>-->

        <!-- <v-tab-item v-model="tab">User Settings</v-tab-item>
        <v-tab-item v-model="tab">Notifications</v-tab-item> -->
        <!-- <v-tab-item v-model="tab">Administrar dispositivos</v-tab-item> -->
      </v-tabs>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Layout'
import { SvgIcon } from '@leapsight/styleguide'
import UserProfile from '@/components/UserSettings/UserProfile'
import AdminDevices from './AdminDevices.vue'

export default {
  components: {
    Layout,
    SvgIcon,
    UserProfile,
    AdminDevices
  }
}
</script>

<style scoped></style>
